export default __webpack_public_path__ + "static/media/swan-logo-blue.d2c50142.svg";